const COMMON_DATE_RANGE_KEY = 'logDateRange';

export const getSessionDateRange = () => {
  const item = sessionStorage.getItem(COMMON_DATE_RANGE_KEY);
  try {
    return JSON.parse(item);
  } catch (e) {
    console.error('Failed to parse date range from session storage:', e);
    return null;
  }
};

export const setSessionDateRange = (start, end) => {
  try {
    sessionStorage.setItem(COMMON_DATE_RANGE_KEY, JSON.stringify({ start, end }));
  } catch (e) {
    console.error('Failed to set date range to session storage:', e);
  }
};

/**
 * Gets date range values, using session storage if not provided
 * @param {string} dateRangeStart - Start date value
 * @param {string} dateRangeEnd - End date value
 * @returns {Object} Object with start and end date values
 */
export const getDateRangeWithSessionFallback = (
  dateRangeStart,
  dateRangeEnd
) => {
  let start = dateRangeStart;
  let end = dateRangeEnd;

  if (!start || !end) {
    const storedDateRange = getSessionDateRange();
    if (storedDateRange?.start && storedDateRange?.end) {
      start = storedDateRange.start;
      end = storedDateRange.end;
    }
  }

  return { start, end };
};
